// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { calibrationCurveId } from './CalibrationCurve';
import { calendarDate } from '../../calendar-date';
import { operatorId } from './Operator';
import { z } from 'zod';
export const calibrationCurveVersionId = (z.number());
export const calibrationCurveVersion = z.object({
    id: calibrationCurveVersionId,
    calibration_curve_id: calibrationCurveId,
    version: z.number(),
    slope: z.string(),
    intercept: z.string(),
    r_squared: z.string().nullable(),
    rt_min: z.string(),
    rt_max: z.string(),
    calibrated_at: calendarDate,
    notes: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const calibrationCurveVersionInitializer = z.object({
    id: calibrationCurveVersionId.optional(),
    calibration_curve_id: calibrationCurveId,
    version: z.number(),
    slope: z.string(),
    intercept: z.string(),
    r_squared: z.string().optional().nullable(),
    rt_min: z.string(),
    rt_max: z.string(),
    calibrated_at: calendarDate,
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const calibrationCurveVersionMutator = z.object({
    id: calibrationCurveVersionId.optional(),
    calibration_curve_id: calibrationCurveId.optional(),
    version: z.number().optional(),
    slope: z.string().optional(),
    intercept: z.string().optional(),
    r_squared: z.string().optional().nullable(),
    rt_min: z.string().optional(),
    rt_max: z.string().optional(),
    calibrated_at: calendarDate.optional(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=CalibrationCurveVersion.js.map